import FormField from 'components/FormField';
import { useTranslate } from '@tolgee/react';
import { FV } from './share';
import useSmartField from 'hooks/useSmartField';
import dayjs, { Dayjs } from 'lib/dayjs';
import { useCallback, useState } from 'react';
import { DisabledProps } from 'views/Aide/Scenario/TaskForm/share';
import { DatePicker, RangePickerProps } from 'components/DatePicker';
import { useFormikContext } from 'formik';
import { useHelpContext } from '../HelpContext';
import { InlineHelp } from '../Help';

export function useGetTimeRangeLabel() {
  const { t } = useTranslate();

  return {
    t,
    getTimeRangeLabel: useCallback(
      (activityType: Knowledge.Activity.Type) => {
        return activityType === 'VOUCHER_GIFT_ACTIVITY'
          ? t('优惠券使用日期')
          : activityType === 'NEW_PRODUCT_ONSALE_ACTIVITY'
          ? t('新品推广期')
          : activityType === 'CLEARANCE_SALE_ACTIVITY'
          ? t('促销日期')
          : activityType === 'LIVE_STREAMING_ACTIVITY'
          ? t('直播日期')
          : activityType === 'RECOMMEND_HOT_PRODUCT_ACTIVITY'
          ? t('爆款商品推广日期')
          : t('act_field_effect_time');
      },
      [t],
    ),
  };
}

function TimeRange({ disabled }: DisabledProps) {
  const { t, getTimeRangeLabel } = useGetTimeRangeLabel();

  const {
    values: { activityType },
  } = useFormikContext<FV>();

  const label = getTimeRangeLabel(activityType);

  const errorText = t('department.请选择x', { x: label });

  const {
    field: { value: from, onChange: onFromChange },
  } = useSmartField<FV['activityFrom']>('activityFrom');

  const [range, setRange] = useState<[Dayjs | null, Dayjs | null]>([null, null]);

  const {
    stepState: [, setHelpStep],
  } = useHelpContext();

  return (
    <FormField<FV['activityTo']>
      name="activityTo"
      required
      label={label}
      validate={(to) => (!(from && to) ? errorText : undefined)}
    >
      {({ field: { value: to, onChange: onToChange, onBlur } }) => {
        const value: RangePickerProps['value'] = from && to ? [dayjs(from), dayjs(to)] : undefined;

        const picker = (
          <DatePicker.RangePicker
            className="w-[352px]"
            disabled={disabled}
            showTime={
              activityType === 'LIVE_STREAMING_ACTIVITY'
                ? false
                : {
                    defaultValue: [
                      dayjs('00:00:00', 'HH:mm:ss'),
                      range[0]
                        ? range[0].clone().subtract(1, 'second')
                        : dayjs('00:00:00', 'HH:mm:ss'),
                    ],
                    showSecond: false,
                  }
            }
            allowClear={false}
            format={activityType === 'LIVE_STREAMING_ACTIVITY' ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm'}
            value={value}
            onCalendarChange={(range) => range && setRange(range)}
            onChange={(_, [from, to]) => {
              onFromChange(activityType === 'LIVE_STREAMING_ACTIVITY' ? `${from} 00:00` : from);
              onToChange(activityType === 'LIVE_STREAMING_ACTIVITY' ? `${to} 23:59` : to);
            }}
            onOpenChange={(open) => !open && setTimeout(onBlur)}
            onFocus={() => setHelpStep('活动生效期')}
          />
        );

        return <InlineHelp step="活动生效期">{picker}</InlineHelp>;
      }}
    </FormField>
  );
}

export default TimeRange;
